"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_router_1 = require("react-router");
var components_1 = require("../../youwell-common/components");
var urls_1 = __importDefault(require("../../app/urls"));
var outsideService_1 = require("../../app/services/outsideService");
var store_1 = require("../../app/store");
var ModuleBoxWithOverlay_1 = __importDefault(require("../inside/components/ModuleBoxWithOverlay"));
var components_2 = require("../../common/components");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d;
    return (0, core_1.createStyles)({
        root: (_a = {
                padding: theme.spacing(6, 12)
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(3, 4.5),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(1.5),
            },
            _a),
        content: {
            marginTop: theme.spacing(8),
        },
        modules: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        moduleTitle: {
            borderLeft: theme.youwell.borders.secondary,
            borderLeftWidth: 4,
            paddingLeft: theme.spacing(2),
            marginBottom: theme.spacing(2),
            outline: 'none',
        },
        module: (_b = {
                flexBasis: "calc(-".concat(theme.spacing(4), "px + 33.3333%)"),
                marginBottom: theme.spacing(4),
                '&:nth-child(3n+2)': (_c = {},
                    _c[theme.breakpoints.up('md')] = {
                        marginLeft: theme.spacing(6),
                        marginRight: theme.spacing(6),
                    },
                    _c)
            },
            _b[theme.breakpoints.down('sm')] = {
                flexBasis: "calc(-".concat(theme.spacing(2), "px + 50%)"), // IE calc. Renders wrong for `calc((100% - ${theme.spacing(4)}px) / 2)`
            },
            _b['&:nth-child(2n + 1)'] = (_d = {},
                _d[theme.breakpoints.down('sm')] = {
                    marginRight: theme.spacing(4),
                },
                _d[theme.breakpoints.down('xs')] = {
                    marginRight: 0,
                },
                _d),
            _b[theme.breakpoints.down('xs')] = {
                flexBasis: '100%',
                justifyContent: 'center',
            },
            _b),
    });
});
var ProgramPage = function () {
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var programIdFromParams = (0, react_router_1.useParams)().programId;
    var publicProgramId = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.pageSettings.appConfig) === null || _a === void 0 ? void 0 : _a.publicProgramId; });
    var programId = programIdFromParams !== null && programIdFromParams !== void 0 ? programIdFromParams : publicProgramId;
    var program = (0, store_1.useYouwellSelector)(function (state) { return state.outsideStore.programDetails[programId]; });
    var loading = (0, store_1.useYouwellSelector)(function (state) { return state.requestStatusStore.loading; });
    (0, react_1.useEffect)(function () {
        if (!program && programId) {
            (0, outsideService_1.fetchOutsideProgram)(dispatch, programId);
        }
    }, [dispatch, program, programId]);
    if (!programId) {
        return (react_1.default.createElement(react_router_1.Redirect, { to: urls_1.default.home }));
    }
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(components_1.Loading, { loading: loading }),
        react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(core_1.Typography, { variant: "h6", className: classes.moduleTitle, tabIndex: -1 }, program === null || program === void 0 ? void 0 : program.name),
            !loading && !program && (react_1.default.createElement(components_2.InfoMessage, { messageKey: "noContent" })),
            react_1.default.createElement("div", { className: classes.modules }, program === null || program === void 0 ? void 0 : program.modules.map(function (module, i) { return (react_1.default.createElement(ModuleBoxWithOverlay_1.default, { key: module.id, programId: program.id, element: {
                    module: module,
                    name: module.name,
                }, index: i, className: classes.module, to: "".concat(urls_1.default.outsideProgram.task, "/").concat(programId, "/").concat(i, "/0") })); })))));
};
exports.default = ProgramPage;
